export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 30,
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  city: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexBasis: '23%',
    marginRight: 14,
    marginTop: 34,
  },
  selectAllButton: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
  },
  selectAllTitle: {
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 16,
    marginLeft: 6,
    fontWeight: 600,
  },
  name: {
    fontSize: 14,
    margin: '0 10px',
    fontFamily: "'Proxima Nova', sans-serif",
    '&:hover': {
      cursor: 'pointer',
    },
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chip: {
    fontSize: 14,
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: 10,
    padding: '4px 10px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chipActive: {
    backgroundColor: '#E0F5E2',
    color: '#00840D',
  },
  chipInactive: {
    backgroundColor: '#E4E4EA',
    color: '#707087',
  },
}
